// extracted by mini-css-extract-plugin
module.exports = {"container":"_8Pk3Z09I","backBtn":"_2ajd-2LJ"};